import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestDestinationsComponent } from './request-destinations/request-destinations.component';
import {BaseModule} from "../../../base/base.module";
import {SharedModule} from "../../../shared/shared/shared.module";
import {ReactiveFormsModule} from "@angular/forms";

@NgModule({
  imports: [
    CommonModule,
    BaseModule,
    SharedModule,
    ReactiveFormsModule
  ],
  declarations: [RequestDestinationsComponent]
})
export class ReportModule { }
